/** A manual warehouse confirmation must explain why unit scanning was not used. */
export function requestWarehouseManualReason(action: string): string | null {
  const reason = window.prompt(`${action}: enter the reason for confirming without individual scans. This will be recorded in the audit history.`);
  return reason?.trim() || null;
}
